import { getSearchParam } from "components/DataGrid/helpers/searchParams";

// @ts-expect-error - any is expected here because we are using console debug statements.
export function debug(...args) {
  if (getSearchParam("debugDatagrid")) console.debug(...args);
}
